import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { loginRequest } from "../config/authConfig";
import { selectAuthError } from "../store/Auth/authSlice";

const PublicRoute = ({ children }) => {
  const { instance, accounts } = useMsal();
  const authError = useSelector(selectAuthError);
  const basicUser = useSelector((state) => state.auth.user);
  const authInitialized = useSelector((state) => state.auth.initialized);

  const [isAuthenticated, setIsAuthenticated] = useState(undefined);

  useEffect(() => {
    // Wait until auth is initialized
    if (!authInitialized) return;

    const checkAuth = async () => {
      // BASIC AUTH check
      if (basicUser) {
        setIsAuthenticated(true);
        return;
      }

      // AZURE check
      if (accounts.length === 0 || authError) {
        setIsAuthenticated(false);
        return;
      }

      try {
        const response = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        });
        setIsAuthenticated(!!response.accessToken);
      } catch (error) {
        console.error("Token refresh failed:", error);
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, [authInitialized, instance, accounts, authError, basicUser]);

  // Show a spinner until both initialization is done and authentication check is completed
  if (!authInitialized || isAuthenticated === undefined) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return isAuthenticated ? <Navigate to="/home" /> : children;
};

export default PublicRoute;
